import { getEntities, getError, isCreating, getEntity } from './_utils'

export const getOfflineReviews = getEntities('offlineReviews')
export const getOfflineReview = getEntity('offlineReviews')
export const creatingOfflineReviews = isCreating('/api/offlinereviews/import')
export const getOfflineReviewsError = getError('/api/offlinereviews/import')
